var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaduta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1.25L4.7 6.3101",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64014 5.32511L11.0751 1.36011",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 14.5L10.0901 11.705C9.93506 11.23 9.54506 10.87 9.05506 10.755L6.43506 10.155",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1899 3.58C5.97139 3.58 6.6049 2.94648 6.6049 2.165C6.6049 1.38352 5.97139 0.75 5.1899 0.75C4.40842 0.75 3.7749 1.38352 3.7749 2.165C3.7749 2.94648 4.40842 3.58 5.1899 3.58Z",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64502 5.14489C6.26002 4.96989 6.90002 5.31989 7.07502 5.93489L7.89002 8.76489L10.645 8.66989C11.06 8.65489 11.47 8.72989 11.855 8.88989L14 10",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43482 10.1549C6.06982 10.0449 5.76982 9.75994 5.65482 9.36994L4.69482 6.31494",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49023 14.4351H9.00023",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 12.095L8.72016 12.935",
    stroke: "#6A6E83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaduta);
export default __webpack_public_path__ + "static/media/caduta.4faeac19618f44a6d1df2d0e7faa16ab.svg";
export { ForwardRef as ReactComponent };